import { PropsWithChildren } from 'react'

type BodyProps = {}

export const Body = ({ children }: PropsWithChildren<BodyProps>) => {
  return <div className="flex-none">{children}</div>
}
